// 评价api

import {baseRequest} from './base'

import store from '../vuex'

/**
 * @desc 查询评价列表
 */
function getEvaluationList(params){
  //如果选择了学校，加入学校字段
  if(store.getters.schoolId){
    params = params ? params : {};
    params.schoolId = store.getters.schoolId;
  }

  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/teaEvaluation/'
  return baseRequest(tempUrl,'get',params);
}

/**
 * @desc 根据评价ID获取评价信息
 */
function getEvaluationById(id){
  return baseRequest(`/api/pcWeb/teaEvaluation/${id}`,'get');
}

/**
 * @desc 新增评价
 */
function addEvaluation(params){
  //如果有价格乘以100
  if(params){
    if(params.EvaluationPrice){
      params.EvaluationPrice = params.EvaluationPrice * 100;
    }
    if(params.textbookPrice){
      params.textbookPrice = params.textbookPrice * 100;
    }
  }
  return baseRequest(`/api/pcWeb/teaEvaluation/create`,'post',params);
}


/**
 * @desc 审核评价
 */
function check(params){
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/teaEvaluation/check/'
  return baseRequest(tempUrl,'get',params);
}

/**
 * @desc 删除评价
 */
function deleteEvaluation(id){
  return baseRequest(`/api/pcWeb/teaEvaluation/delete/${id}`,'get');
}

/**
 * @desc 修改评价
 */
function updateEvaluation(id,params){
  return baseRequest(`/api/pcWeb/teaEvaluation/update/${id}`,'post',params);
}

export default {
  getEvaluationList: getEvaluationList,
  getEvaluationById: getEvaluationById,
  addEvaluation: addEvaluation,
  deleteEvaluation: deleteEvaluation,
  updateEvaluation: updateEvaluation,
  check: check,
}